import React from 'react';
import { connect } from 'react-redux';

class Footer extends React.Component {
  render() {
    let overrideStyle;
    if (this.props.isLogin) {
      overrideStyle = {
        marginTop: '0px',
        bottom: '0'
      };
    } else if (this.props.isPsycho) {
      overrideStyle = {
        bottom: '-5rem'
      };
    } else if (this.props.isResults) {
      overrideStyle = {
        bottom: '-6rem'
      };
    }

    // Soft, small footer links - muted rather than stark white.
    const linkStyle = {
      color: 'rgba(255, 255, 255, 0.6)',
      fontSize: '0.8rem',
      fontWeight: 400,
      textDecoration: 'none',
    };

    return <footer className='footer' style={overrideStyle}>
      <div className='container is-fluid'>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '1rem',
            padding: '1.25rem 0',
          }}
        >
          {/* Left: links in a row */}
          <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '1.25rem' }}>
            <a href='https://app-portal.competas.com/privacy-policy' target='_blank' rel='noopener noreferrer' style={linkStyle}>Privacy Policy</a>
            <a href='https://app-portal.competas.com/terms-of-service' target='_blank' rel='noopener noreferrer' style={linkStyle}>Terms of Service</a>
          </div>
          {/* Right: logo */}
          <img className='md-logo' src='/assets/img/logoDarkBgWhiteFont.png' alt='Competas' style={{ width: '130px', display: 'block' }} />
        </div>
      </div>
    </footer>;
  }
}

export default connect()(Footer);



// WEBPACK FOOTER //
// ./src/components/footer/Footer.jsx